import * as s from "./website-content.scss";
import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {WebsiteBlackScoreComponent} from "../black/score/WebsiteBlackScoreComponent";
import {WebsiteBlackFlowStepsComponent} from "../black/flow/steps/WebsiteBlackFlowStepsComponent";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {WebsiteBlackFlowGridComponent} from "../black/flow/grid/WebsiteBlackFlowComponent";
import {WebsiteBlackWorkflowComponent} from "../black/workflow/WebsiteBlackWorkflowComponent";
import {Resources} from "../../../../../resources/Resources";

export class WebsiteContentEditorComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.editorCreateContentFree"),
                            title: Resources.t("words.editorTrustYourContent"),
                            titleMaxWidth: 480,
                            description: Resources.t("words.editorSmartSeoEditorDescription"),
                            people: false,
                            center: true,
                            background: "score"
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackScoreComponent())}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackFlowStepsComponent({
                            divide: {
                                what: Resources.t("words.editorHowItWorks"),
                                description: Resources.t("words.editorSecretAlgorithms"),
                                stepText: Resources.t("words.editorSearchIllustrationText"),
                                steps: [
                                    {
                                        step: "1",
                                        title: Resources.t("words.editorStepOneTitle"),
                                        description: Resources.t("words.editorStepOneDescription")
                                    },
                                    {
                                        step: "2",
                                        title: Resources.t("words.editorStepTwoTitle"),
                                        description: Resources.t("words.editorStepTwoDescription"),
                                    },
                                    {
                                        step: "3",
                                        title: Resources.t("words.editorStepThreeTitle"),
                                        description: Resources.t("words.editorStepThreeDescription")
                                    }
                                ]
                            },
                            union: {
                                description: Resources.t("words.editorMissionStatement"),
                                steps: [
                                    {
                                        step: "1",
                                        title: Resources.t("words.editorSearchResults"),
                                        description: Resources.t("words.editorFirstTenResults")
                                    }, {
                                        step: "2",
                                        title: Resources.t("words.editorIdentifyingCommonalities"),
                                        description: Resources.t("words.editorIdentifyingTermsAndMetrics"),
                                        image: NetworkVendor.image("blog-ah.webp"),
                                        imageAlt: Resources.t("words.auditCommonPoints")
                                    }, {
                                        step: "3",
                                        title: Resources.t("words.editorSuggestionsRecommendations"),
                                        description: Resources.t("words.editorRealTimeOptimizationSuggestions"),
                                        image: NetworkVendor.image("blog-r.webp"),
                                        imageAlt: Resources.t("words.editorSeoContentScore")
                                    }
                                ]
                            }
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowGridComponent({
                                        title: Resources.t("words.editorThreePercentMessage"),
                                        lines: [
                                            {
                                                entries: [
                                                    {
                                                        title: Resources.t("words.editorFiveHundredMetrics"),
                                                        description: Resources.t("words.editorFiveHundredMetricsDescription"),
                                                        illustration: "metrics"
                                                    },
                                                    {
                                                        title: Resources.t("words.editorCompetitiveAnalysis"),
                                                        description: Resources.t("words.editorCompetitiveAnalysisDescription"),
                                                        image: NetworkVendor.image("blog-z.webp"),
                                                        imageAlt: Resources.t("words.editorCompetitiveAnalysis"),
                                                        large: true
                                                    }
                                                ]
                                            }, {
                                                entries: [
                                                    {
                                                        title: Resources.t("words.editorMultiLanguage"),
                                                        description: Resources.t("words.editorMultiLanguageDescription"),
                                                        illustration: "languages"
                                                    },
                                                    {
                                                        title: Resources.t("words.editorAutoOptimization"),
                                                        description: Resources.t("words.editorAutoOptimizationDescription"),
                                                        illustration: "score"
                                                    },
                                                    {
                                                        title: Resources.t("words.editorCollaborativeEditor"),
                                                        description: Resources.t("words.editorCollaborativeEditorDescription"),
                                                        illustration: "editor"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                            ))}
                        </div>
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackWorkflowComponent())}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
